import Sermon from "./Sermon";
import classes from "./Sermons.module.css";
import {useDispatch, useSelector} from "react-redux";
import {useEffect, useState} from "react";
import spinner from '../assets/ajax-loader.gif';
import getAllSermons from "../services/SermonService";
import {sermonActions} from "../store";

const Sermons = () => {
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        const callServer = async () => {
            setLoading(true);
            const result = await getAllSermons();
            dispatch(sermonActions.setAllSermons(result.data));
            setLoading(false);
        };
		callServer();
    }, [dispatch])

    const sermons = useSelector(state => state.filteredSermons);
    const searchCriteria = useSelector(state => state.filterText);
    if (loading) {
        return 	<div className="container">
					<div className="row">
						<div className="col">
							<img src={spinner} alt="Spinning loading indicator while waiting for sermon list to load"/>
						</div>
					</div>
				</div>
    } else {
		let content = null;
		if (sermons === null || sermons.length === 0) {
			if (!searchCriteria || searchCriteria.trim().length === 0) {
				// there is no search criteria so, we assume that all sermons are being shown, so there must not be any in the database
				content = <p className="text-danger font-weight-bold">No sermons exist in database</p>;
			} else {
				// search criteria is populated, so there must not be any sermons matching the search criteria entered by user
				content = <p className="text-danger font-weight-bold">No sermons found for search criteria: {searchCriteria}</p>;
			}
		} else {
			// Either all sermons are being displayed, or whatever the user entered for search criteria matched records in DB
			content = sermons.map(sermon => <Sermon key={sermon.index} thisSermon={sermon}/>);
		}
        return (
            <div className={`sermons-green-bg white-text p-4 ${classes['rounded-corners']}`}>
                {content}
            </div>
        );
    }
}
export default Sermons;